import api from "./api.js";
import { resolverEstabelecimentoAtivoId } from "../utils/estabelecimentoContext";

const agendaExcecoes = {
  listar: async (estabelecimentoId, mes) => {
    const id = resolverEstabelecimentoAtivoId(estabelecimentoId);
    const params = mes ? `?mes=${encodeURIComponent(mes)}` : "";
    const response = await api.get(
      `/agenda-excecoes/estabelecimento/${id}${params}`
    );
    return response.data;
  },

  criar: async (estabelecimentoId, dados) => {
    const id = resolverEstabelecimentoAtivoId(estabelecimentoId);
    const response = await api.post(
      `/agenda-excecoes/estabelecimento/${id}`,
      dados
    );
    return response.data;
  },

  remover: async (estabelecimentoId, excecaoId) => {
    const id = resolverEstabelecimentoAtivoId(estabelecimentoId);
    const response = await api.delete(
      `/agenda-excecoes/estabelecimento/${id}/${excecaoId}`
    );
    return response.data;
  },
};

export default agendaExcecoes;
